export const TYPES = [ 'success', 'info', 'warning', 'error' ];
